/* ==========================================================================
   campana.js · Landing de campaña (collection.campana).
   Se carga SOLO en esa plantilla. No modifica el comportamiento del tema:
   el agregado rápido y la vista rápida siguen siendo del tema (Palo Alto).
   Funciones: estados + countdown, texto del sello, barra de chips fija,
   ocultar header al bajar (móvil), navegación por anclas / deep links de Paid
   (#infusiones, #velas, ...), chip activo por posición, pestañas y "Ver más".
   ========================================================================== */
(function () {
  'use strict';

  var html = document.documentElement;
  if (!html.classList.contains('cmp-landing')) return;

  var mqMovil = window.matchMedia('(max-width: 749px)');
  var cfg, fin, ultimo, manual, ocultarHeader;

  function fecha(v) { var d = Date.parse(v || ''); return isNaN(d) ? null : d; }
  function dos(n) { return n < 10 ? '0' + n : String(n); }

  function leerConfig() {
    cfg = document.querySelector('[data-cmp-config]');
    fin = cfg ? fecha(cfg.getAttribute('data-fin')) : null;
    ultimo = cfg ? fecha(cfg.getAttribute('data-ultimo')) : null;
    manual = cfg ? (cfg.getAttribute('data-estado-manual') || 'auto') : 'auto';
    ocultarHeader = cfg ? cfg.getAttribute('data-ocultar-header') === 'true' : false;
  }
  leerConfig();

  function estadoActual() {
    if (manual !== 'auto') return manual;
    var ahora = Date.now();
    if (fin && ahora > fin) return 'finalizado';
    if (ultimo && ahora >= ultimo) return 'ultimo';
    return 'activo';
  }

  /* ---------- Texto del sello (único punto: Campaña · Configuración) ---------- */
  function aplicarSello(raiz) {
    if (!cfg) return;
    var textoSello = cfg.getAttribute('data-sello');
    var centroSello = cfg.getAttribute('data-sello-centro');
    if (textoSello) raiz.querySelectorAll('[data-cmp-sello-texto]').forEach(function (el) { el.textContent = textoSello; });
    if (centroSello) raiz.querySelectorAll('[data-cmp-sello-centro]').forEach(function (el) { el.textContent = centroSello; });
  }
  aplicarSello(document);

  /* ---------- Estados + countdown ---------- */
  function tick() {
    var estado = estadoActual();
    if (html.getAttribute('data-cmp-estado') !== estado) html.setAttribute('data-cmp-estado', estado);
    if (!fin) return;
    var resta = Math.max(0, fin - Date.now());
    var s = Math.floor(resta / 1000);
    var d = Math.floor(s / 86400);
    var h = Math.floor((s % 86400) / 3600);
    var m = Math.floor((s % 3600) / 60);
    var seg = s % 60;
    document.querySelectorAll('[data-cmp-countdown]').forEach(function (el) {
      var tipo = el.getAttribute('data-cmp-countdown');
      if (tipo === 'pill') {
        if (estado === 'ultimo') {
          el.textContent = 'Último día · ' + dos(d * 24 + h) + ':' + dos(m) + ':' + dos(seg);
        } else {
          el.textContent = 'Termina en ' + (d > 0 ? d + 'd ' : '') + h + 'h ' + dos(m) + 'm';
        }
      } else if (tipo === 'cajas') {
        var cd = el.querySelector('[data-u="d"]');
        var ch = el.querySelector('[data-u="h"]');
        var cm = el.querySelector('[data-u="m"]');
        if (cd) cd.textContent = dos(d);
        if (ch) ch.textContent = dos(h);
        if (cm) cm.textContent = dos(m);
      }
    });
  }
  tick();
  window.setInterval(tick, 1000);

  /* ---------- Barra de chips fija + header que se oculta (móvil) ---------- */
  /* La barra se fija con position: fixed (clase is-fixed) midiendo el contenedor de la
     sección: no depende de position: sticky ni del overflow de los contenedores del tema. */
  var ultimoY = window.pageYOffset;
  var enCola = false;
  var bloqueado = false;
  var saltoActivo = false;
  var temporizador = null;

  function obtenerNav() { return document.querySelector('[data-cmp-nav]'); }
  function alturaHeader() {
    var v = parseFloat(window.getComputedStyle(document.body).getPropertyValue('--header-sticky-height'));
    return isNaN(v) ? 60 : v;
  }
  function ocultaHeaderEnMovil() { return ocultarHeader && mqMovil.matches; }
  /* Distancia desde el borde superior a la que debe quedar el título de una sección. */
  function margenAncla(headerOculto) {
    var nav = obtenerNav();
    var altoNav = nav ? nav.offsetHeight : 0; /* offsetHeight es 0 si la barra está oculta (campaña finalizada) */
    return altoNav + (headerOculto ? 0 : alturaHeader()) + 12;
  }
  function actualizarMargen() {
    html.style.setProperty('--cmp-offset', margenAncla(ocultaHeaderEnMovil()) + 'px');
  }

  function alScroll() {
    enCola = false;
    var y = window.pageYOffset;
    var nav = obtenerNav();
    if (nav) {
      var contenedor = nav.closest('.cmp-nav-section') || nav.parentElement;
      var tope = html.classList.contains('cmp-header-oculto') ? 0 : alturaHeader();
      var fija = contenedor.getBoundingClientRect().top <= tope + 1;
      nav.classList.toggle('is-fixed', fija);
      if (!bloqueado) {
        if (ocultaHeaderEnMovil() && fija) {
          if (y > ultimoY + 6) html.classList.add('cmp-header-oculto');
          else if (y < ultimoY - 6) html.classList.remove('cmp-header-oculto');
        } else {
          html.classList.remove('cmp-header-oculto');
        }
      }
    }
    ultimoY = y;
    actualizarChip();
  }
  window.addEventListener('scroll', function () {
    if (!enCola) { enCola = true; window.requestAnimationFrame(alScroll); }
  }, { passive: true });
  window.addEventListener('resize', function () { alScroll(); actualizarMargen(); });

  /* ---------- Anclas / deep links (#infusiones, #velas, ...) ---------- */
  function limpiarId(v) { return String(v || '').replace(/^#/, '').replace(/[^A-Za-z0-9_-]/g, ''); }
  /* Busca el ancla SOLO dentro de la landing (evita choques con IDs del tema). */
  function buscarAncla(v) {
    var id = limpiarId(v);
    if (!id) return null;
    var el = document.getElementById(id);
    if (el && el.closest('.cmp')) return el;
    return document.querySelector('.cmp[id="' + id + '"], .cmp [id="' + id + '"]');
  }

  /* Desplaza una fila horizontal (chips o pestañas) para dejar visible un elemento. */
  function desplazarDentro(cont, el, centrar) {
    if (!cont || !el || cont.scrollWidth <= cont.clientWidth) return;
    var d = el.getBoundingClientRect().left - cont.getBoundingClientRect().left;
    var ajuste = centrar ? d - (cont.clientWidth - el.offsetWidth) / 2 : d - 16;
    if (cont.scrollBy) cont.scrollBy({ left: ajuste, behavior: 'smooth' });
    else cont.scrollLeft += ajuste;
  }

  var chipActivo = null;
  function marcarChip(id) {
    var chip = id ? document.querySelector('[data-cmp-chip="' + limpiarId(id) + '"]') : null;
    if (chip === chipActivo) return;
    if (chipActivo) { chipActivo.classList.remove('is-active'); chipActivo.removeAttribute('aria-current'); }
    chipActivo = chip;
    if (!chip) return;
    chip.classList.add('is-active');
    chip.setAttribute('aria-current', 'true');
    desplazarDentro(chip.parentElement, chip, false);
  }

  /* Chip activo según la sección que ocupa la zona de lectura: una línea justo debajo del
     header + barra de chips (30 % del área visible). Sin chip activo por encima de la primera
     sección ni después de la última; en los espacios entre secciones se mantiene la anterior. */
  function actualizarChip() {
    if (bloqueado) return;
    var nav = obtenerNav();
    var chips = document.querySelectorAll('[data-cmp-chip]');
    if (!nav || !chips.length) return;
    var obst = nav.classList.contains('is-fixed') ? nav.getBoundingClientRect().bottom : 0;
    var hdr = document.querySelector('.shopify-section-header');
    if (hdr) obst = Math.max(obst, hdr.getBoundingClientRect().bottom);
    var linea = obst + (window.innerHeight - obst) * 0.3;
    var secciones = [];
    chips.forEach(function (c) {
      var el = buscarAncla(c.getAttribute('data-cmp-chip'));
      if (el) { var q = el.getBoundingClientRect(); secciones.push({ id: el.id, top: q.top, bottom: q.bottom }); }
    });
    if (!secciones.length) return;
    secciones.sort(function (a, b) { return a.top - b.top; });
    var dentro = secciones.filter(function (s) { return s.top <= linea && s.bottom > linea; });
    var id = null;
    if (dentro.length) {
      var actual = chipActivo ? chipActivo.getAttribute('data-cmp-chip') : null;
      id = dentro.some(function (s) { return s.id === actual; }) ? actual : dentro[0].id;
    } else {
      var previas = secciones.filter(function (s) { return s.top <= linea; });
      if (previas.length && linea < secciones[secciones.length - 1].bottom) id = previas[previas.length - 1].id;
    }
    marcarChip(id);
  }

  /* Si el usuario desliza mientras dura un salto por ancla, el salto se cancela:
     nunca se le devuelve a la sección anterior. */
  function cancelarSalto() {
    if (!saltoActivo) return;
    saltoActivo = false;
    window.clearInterval(temporizador);
    bloqueado = false;
    ultimoY = window.pageYOffset;
  }
  ['wheel', 'touchmove', 'keydown'].forEach(function (ev) {
    window.addEventListener(ev, cancelarSalto, { passive: true });
  });

  /* Lleva a una sección dejando su título visible bajo el header + la barra de chips.
     Tras el desplazamiento se corrige cualquier diferencia (imágenes o fuentes que
     terminan de cargar), así el título nunca queda tapado. */
  function irA(v, suave) {
    var el = buscarAncla(v);
    if (!el) return false;
    var esInicio = el.id === 'inicio';
    var headerOculto = esInicio ? false : ocultaHeaderEnMovil();
    bloqueado = true;
    saltoActivo = true;
    window.clearInterval(temporizador);
    html.classList.toggle('cmp-header-oculto', headerOculto);
    var destino = esInicio ? 0 : el.getBoundingClientRect().top + window.pageYOffset - margenAncla(headerOculto);
    window.scrollTo({ top: Math.max(0, Math.round(destino)), behavior: suave ? 'smooth' : 'auto' });
    if (!esInicio) marcarChip(el.id);
    var previo = -1;
    var quietos = 0;
    var vueltas = 0;
    temporizador = window.setInterval(function () {
      var y = window.pageYOffset;
      vueltas += 1;
      quietos = Math.abs(y - previo) < 1 ? quietos + 1 : 0;
      previo = y;
      if (quietos < 2 && vueltas < 30) return;
      window.clearInterval(temporizador);
      if (!saltoActivo) return;
      if (!esInicio) {
        var diferencia = el.getBoundingClientRect().top - margenAncla(headerOculto);
        if (Math.abs(diferencia) > 2) window.scrollTo(0, Math.max(0, Math.round(window.pageYOffset + diferencia)));
      }
      window.setTimeout(function () {
        if (!saltoActivo) return;
        saltoActivo = false;
        ultimoY = window.pageYOffset;
        bloqueado = false;
        actualizarChip();
      }, 120);
    }, 100);
    return true;
  }

  function initAnclas(raiz) {
    raiz.querySelectorAll('a[href^="#"]').forEach(function (a) {
      if (a.hasAttribute('data-cmp-ancla') || !a.closest('.cmp')) return;
      a.setAttribute('data-cmp-ancla', '');
      a.addEventListener('click', function (e) {
        var el = buscarAncla(a.getAttribute('href'));
        if (!el) return;
        e.preventDefault();
        e.stopPropagation();
        irA(el.id, true);
        if (window.history && window.history.replaceState) {
          var base = window.location.pathname + window.location.search;
          window.history.replaceState(null, '', el.id === 'inicio' ? base : base + '#' + el.id);
        }
      });
    });
  }
  initAnclas(document);

  /* Entrada directa con ancla (anuncios de Paid): se posiciona al cargar y se reajusta
     cuando terminan de cargar imágenes y fuentes, salvo que el usuario ya se haya movido. */
  var usuarioMovio = false;
  ['wheel', 'touchmove', 'keydown'].forEach(function (ev) {
    window.addEventListener(ev, function () { usuarioMovio = true; }, { passive: true, once: true });
  });
  var anclaInicial = buscarAncla(window.location.hash);
  if (anclaInicial && anclaInicial.id !== 'inicio') {
    irA(anclaInicial.id, false);
    var reajustar = function () { if (!usuarioMovio) irA(anclaInicial.id, false); };
    window.addEventListener('load', reajustar);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(reajustar);
  }
  window.addEventListener('hashchange', function () {
    var el = buscarAncla(window.location.hash);
    if (el) irA(el.id, false);
  });
  actualizarMargen();
  alScroll();

  /* ---------- "Ver más" (sin recargar) ---------- */
  function claseOculta() { return mqMovil.matches ? 'cmp-mas-m' : 'cmp-mas-d'; }

  function actualizarBoton(lista) {
    var btn = lista.querySelector('[data-cmp-ver-mas]');
    if (!btn) return;
    btn.hidden = lista.querySelectorAll('.' + claseOculta()).length === 0;
  }

  function initListas(raiz) {
    raiz.querySelectorAll('[data-cmp-lista]').forEach(function (lista) {
      var btn = lista.querySelector('[data-cmp-ver-mas]');
      if (!btn || btn.hasAttribute('data-cmp-listo')) return;
      btn.setAttribute('data-cmp-listo', '');
      btn.addEventListener('click', function () {
        var cls = claseOculta();
        var lote = parseInt(lista.getAttribute(mqMovil.matches ? 'data-lote-m' : 'data-lote-d'), 10) || 8;
        var ocultas = lista.querySelectorAll('.' + cls);
        var primera = null;
        for (var i = 0; i < ocultas.length && i < lote; i++) {
          ocultas[i].classList.remove('cmp-mas-m', 'cmp-mas-d');
          if (!primera) primera = ocultas[i];
        }
        lista.classList.add('is-abierta');
        actualizarBoton(lista);
        if (primera) {
          var enlace = primera.querySelector('.cmp-card__title a');
          if (enlace) enlace.focus({ preventScroll: true });
        }
      });
      actualizarBoton(lista);
    });
  }
  initListas(document);

  var cambioMq = function () {
    document.querySelectorAll('[data-cmp-lista]').forEach(actualizarBoton);
    actualizarMargen();
  };
  if (mqMovil.addEventListener) mqMovil.addEventListener('change', cambioMq);
  else if (mqMovil.addListener) mqMovil.addListener(cambioMq);

  /* ---------- Pestañas ---------- */
  function initTabs(raiz) {
    raiz.querySelectorAll('[data-cmp-tabs]').forEach(function (grupo) {
      if (grupo.hasAttribute('data-cmp-listo')) return;
      grupo.setAttribute('data-cmp-listo', '');
      var tabs = Array.prototype.slice.call(grupo.querySelectorAll('[role="tab"]'));
      var fila = grupo.querySelector('.cmp-tabs');
      /* Sin degradado al final cuando ya no queda nada a la derecha (o todo entra). */
      function marcarFin() {
        if (fila) fila.classList.toggle('is-fin', fila.scrollLeft + fila.clientWidth >= fila.scrollWidth - 2);
      }
      if (fila) {
        fila.addEventListener('scroll', marcarFin, { passive: true });
        window.addEventListener('resize', marcarFin);
        marcarFin();
      }
      function activar(tab, enfocar) {
        tabs.forEach(function (t) {
          var sel = t === tab;
          t.setAttribute('aria-selected', sel ? 'true' : 'false');
          t.tabIndex = sel ? 0 : -1;
          var panel = document.getElementById(t.getAttribute('aria-controls'));
          if (panel) panel.hidden = !sel;
        });
        if (enfocar) tab.focus({ preventScroll: true });
        desplazarDentro(fila, tab, true);
        var panelActivo = document.getElementById(tab.getAttribute('aria-controls'));
        if (panelActivo) panelActivo.querySelectorAll('[data-cmp-lista]').forEach(actualizarBoton);
      }
      tabs.forEach(function (tab, i) {
        tab.addEventListener('click', function () { activar(tab, false); });
        tab.addEventListener('keydown', function (e) {
          var destino = null;
          if (e.key === 'ArrowRight') destino = tabs[(i + 1) % tabs.length];
          else if (e.key === 'ArrowLeft') destino = tabs[(i - 1 + tabs.length) % tabs.length];
          else if (e.key === 'Home') destino = tabs[0];
          else if (e.key === 'End') destino = tabs[tabs.length - 1];
          if (destino) { e.preventDefault(); activar(destino, true); }
        });
      });
    });
  }
  initTabs(document);

  /* ---------- Editor de temas: re-inicializa una sección al editarla ---------- */
  document.addEventListener('shopify:section:load', function (e) {
    var raiz = e.target;
    leerConfig();
    aplicarSello(raiz);
    initAnclas(raiz);
    initListas(raiz);
    initTabs(raiz);
    actualizarMargen();
    alScroll();
  });
})();
